import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IServerLogFilesListVm } from '../server-log-file-info-vm.model';

@Injectable({ providedIn: 'root' })
export class AdminServerLogFilesService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AdminServerLogFiles`;
  }

  getFilesList(): Observable<IServerLogFilesListVm> {
    const headers = this.createHeaders();
    return this.http.get<IServerLogFilesListVm>(this.baseUrl, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
